import { render, staticRenderFns } from "./hornor.vue?vue&type=template&id=43c41c48&"
import script from "./hornor.vue?vue&type=script&lang=js&"
export * from "./hornor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports